import { QueryCache, QueryClient, MutationCache } from "@tanstack/react-query";
import { showApiErrorToast, shouldRetryRequest } from "./shared/utils/errorHandler";

const MAX_QUERY_RETRIES = 2;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (!shouldRetryRequest(error)) return false;
        return failureCount < MAX_QUERY_RETRIES;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10_000),
      refetchOnWindowFocus: false,
      staleTime: Infinity, // Cache indefinitely by default - refetch manually via invalidateQueries
      gcTime: Infinity, // Never garbage collect cached data
    },
    mutations: {
      retry: false,
    },
  },

  queryCache: new QueryCache({
    onError: (error) => {
      showApiErrorToast(error);
    },
  }),

  mutationCache: new MutationCache({
    onError: (error) => {
      showApiErrorToast(error);
    },
  }),
});
